module.exports = __webpack_public_path__ + "img/default-phone-placeholder.b487e5f0.svg";